import { render, staticRenderFns } from "./EmbedImage.vue?vue&type=template&id=58f2bcca&scoped=true&"
import script from "./EmbedImage.vue?vue&type=script&lang=js&"
export * from "./EmbedImage.vue?vue&type=script&lang=js&"
import style0 from "./EmbedImage.vue?vue&type=style&index=0&id=58f2bcca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f2bcca",
  null
  
)

export default component.exports